import React, { Suspense, useContext, useEffect, useState } from "react";
import DocumentFile from "./DocumentFile";
import { FolderDocumentUpdate, uploadDocFile } from "./DocumentService";
import { GetMasterTypeData } from "../../../Services/Global-Services/GlobalServices";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { TostMsg } from "../../../App";

const DocumentDragDrop = ({ FolderId, onDropFolder }) => {
  const [isOver, setIsOver] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [isDragging, setIsDragging] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  // const [isOverride, setIsOverride] = useState(0);
  const [folderData, setFolderData] = useState({});
  const toster = useContext(TostMsg);

  useEffect(() => {}, []);

  const handleDragEnter = (e) => {
    e.preventDefault();
    //  e.stopPropagation();
    setIsDragging(true);

  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
   
    setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);
    const items = e.dataTransfer.items;
    const allFiles = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        const files = await traverseFileTree(entry);
        // allFiles.push(...files);
        allFiles.push(files);

        // for (let f of allFiles) {
        await processDragDrop(files, FolderId ? FolderId : 0, 0, false);
        // }
      } 
    }
    toster.current.success("Document uploaded successfully");
  };

  function traverseFileTree(item, path = "") {
    return new Promise((resolve) => {
      if (item.isFile) {
        item.file((file) => {
          resolve({
            name: file.name,
            type: "file",

            file,
          });
        });
      } else if (item.isDirectory) {
        const dirReader = item.createReader();

        dirReader.readEntries(async (entries) => {
          let results = [];
          for (let entry of entries) {
            // , path + item.name + "/"
            const nestedFiles = await traverseFileTree(entry);
            //   results.push(...nestedFiles);
            results.push(nestedFiles);
          }
          // resolve(results);
          resolve({
            name: item.name,
            type: "directory",
            DocTypeId: 101,
            results,
          });
        });
      }
    });
  }

  async function onDragDropFile({
    // docPath,
    // fileName,
    // docTypeId,
    folder,
    folderId,
    isOverride,
  }) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: folder?.docPath,
      Name: folder?.fileName,
      Desc: "",
      DocTypeId: folder?.docTypeId,
      IsOverride: isOverride ? isOverride : 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        onDropFolder({ close: true, success: 1 });
        // setIsOverride(0);
        setErrorMessage("");
        setFolderData({});
      } else {
        // setIsOverride(2);
        onDropFolder({ close: true, success: 0 });
        setFolderData({ folder: folder, folderId: folderId, type: "file" });
        setErrorMessage(response?.Message);

        const modalEl = document.getElementById("dragDropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      setIsloading(false);
    } catch (error) {
      // toster.current.error(ERROR_LIST.PostDocument);
      setIsloading(false);
    }
    // }
  }

  async function uploadFolderDocFile(file, folderId, isOverride) {
    setIsloading(true);

    if (file) {
      const formData = new FormData();
      // for (let i = 0; i < file.length; i++) {
      formData.append("files", file);

      // }
      let params = {
        UploadType: UploadFile_KEYS?.Document,
        RefId: 0,
      };

      try {
        const response = await uploadDocFile(params, formData);

        const docPathURL = response?.Data;

        const docPath = docPathURL[0];
        const fileName = docPath.split(/[/\\]/).pop();
        const ext = fileName.split(".").pop();
        let docTypeId = 0;
        if (["jpeg", "jpg", "png"].includes(ext)) docTypeId = 106;
        else if (ext === "pdf") docTypeId = 102;
        else if (["xls", "xlsx", "csv"].includes(ext)) docTypeId = 103;
        else if (["doc", "docx"].includes(ext)) docTypeId = 104;
        else if (["ppt", "pptx"].includes(ext)) docTypeId = 105;
        else if (ext === "mp4") docTypeId = 107;
        else if (ext === "mp3") docTypeId = 108;
        else if (["zip", "rar"].includes(ext)) docTypeId = 109;
         else docTypeId = 110;

        await onDragDropFile({
          folder: {
            docPath: docPath,
            fileName: fileName,
            docTypeId: docTypeId,
          },
          // docPath,
          // fileName,
          // docTypeId,
          folderId,
          isOverride,
        });

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        // toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
      }
    } else {
      setIsloading(false);
      // toster.current.warn("No file selected");
    }
  }

  async function onDragDropFolder(folder, folderId) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: "",
      Name: folder?.name,
      Desc: "",
      DocTypeId: folder?.DocTypeId,
      IsOverride: folder?.IsOverride || 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        // setIsOverride(0);
        setErrorMessage("");
        setFolderData({});
      } else if (response?.StatusCode === 2003) {
        // setIsOverride(2);
        setFolderData({ folder: folder, folderId: folderId, type: "folder" });
        setErrorMessage(response?.Message);

        const modalEl = document.getElementById("dragDropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      return response;
    } catch (error) {
      // toster.current.error(ERROR_LIST.PostFolder);
    }
  }

  async function  processDragDrop(
    folder,
    folderId,
    isOverride = 0,
    isRootOverride = false
  ) {
    try {
      if (folder.type === "file" && isOverride === 0) {
        await uploadFolderDocFile(folder.file, folderId, isOverride);
      } else {
        await onDragDropFile({ folder: folder, folderId, isOverride });
      }

      if (folder.type === "directory") {
        const response = await onDragDropFolder(
          { ...folder, IsOverride: isOverride },
          folderId
        );
        if (response?.StatusCode === 2000) {
          for (const child of folder.results) {
            await processDragDrop(child, response?.Data?.Id, 0, false);
          }

          if (isRootOverride) {
            isOverride = 0;
            // setIsOverride(0);
          }
        }
      }

      // toster.current.success("New document uploaded successfully.");
    } catch (error) {
      // toster.current.error("Upload failed.");
    }
  }

  return (
    <div
      className={`${isDragging ? "drag-active" : ""}`}
   onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div
        className="drop-zone-1"
   
        // style={{
        //   width: "100%",
        //   height: "100%",
        //   display: "flex",
        //   position: "absolute",
        // }}
      >
       
      
          <div className="content">
            <img src="images/document/Drag-drop-img.png"></img>
            <h5>
              Drag and drop files to <b>attach</b> this task
            </h5>
          </div>
        
      </div>

      <div
          className="modal fade"
          id="dragDropErrorMessagePopup"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content p-0">
              <div className="modal-header">
                <h5 className="modal-title error-alert">Error Alert</h5>
                <button
                  type="button"
                  className="btn-close p-0"
                  data-bs-dismiss="modal"
                  //   onClick={onCloseErrorPopup}
                ></button>
              </div>

              <div className="modal-body text-center">
                <span className="text-purple"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-file-earmark mb-2" viewBox="0 0 16 16">
  <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
</svg></span>
                <p className="error-message">{errorMessage}</p>

                <div className="text-center d-flex ">
                  {folderData?.type === "file" && (
                    <>
                      <button
                        type="button"
                        className="cancelbtn-click"
                        data-bs-dismiss="modal"
                        onClick={() => {
                          // setIsOverride(2);
                          processDragDrop(
                            folderData.folder,
                            folderData.folderId,
                            1,
                            true
                          );
                        }}
                      >
                        Replace
                      </button>
                    </>
                  )}

                  <button
                    type="button"
                    className="savebtn-click btn-purple rounded"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      // setIsOverride(2);
                      processDragDrop(
                        folderData.folder,
                        folderData.folderId,
                        2,
                        true
                      );
                    }}
                  >
                    Keep Both
                  </button>
                </div>
              </div>
            </div>
          </div>

          {isLoading ? (
            <Suspense>
              <ComponentLoader />
            </Suspense>
          ) : (
            ""
          )}
        </div>
    </div>

    
  );
};
export default DocumentDragDrop;
